import _ from "lodash";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  EncryptPreLogin,
  DecryptPreLogin,
} from "../../../middleware/CryptoMiddleWare";
import { createEncryptedAsyncThunk } from "../../Utility/APIUtils";

function htmlDecode(input) {
  const doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

const initialState = {
  error: "",
  loading: false,
};

export const getState = createAsyncThunk(
  "UserManagement/getState",
  async () => {
    const rowData = {
      userid: 0,
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}account/GetStateList`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          PT: process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        body: await EncryptPreLogin(JSON.stringify(rowData)),
      }
    );
    const data = await response.text();
    const data1 = await DecryptPreLogin(data);
    const encodedString = data1;
    const res = JSON.parse(htmlDecode(encodedString));
    return res;
  }
);

export const getCity = createAsyncThunk(
  "UserManagement/GetCityList",
  async (params) => {
    const rowData = {
      stateId: `${params.body.stateID}`,
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}account/GetCityList`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          PT: process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        body: await EncryptPreLogin(JSON.stringify(rowData)),
      }
    );
    const data = await response.text();
    const data1 = await DecryptPreLogin(data);
    const encodedString = data1;
    const res = JSON.parse(htmlDecode(encodedString));
    return res;
  }
);

export const getBlock = createAsyncThunk(
  "UserManagement/getBlock",
  async (params) => {
    const rowData = {
      districtId: `${params.body.districtId}`,
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}account/GetBlockList`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          PT: process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        body: await EncryptPreLogin(JSON.stringify(rowData)),
      }
    );
    const data = await response.text();
    const data1 = await DecryptPreLogin(data);
    const encodedString = data1;
    const res = JSON.parse(htmlDecode(encodedString));
    return res;
  }
);

export const getGram = createAsyncThunk(
  "UserManagement/getGramList",
  async (params) => {
    const rowData = {
      blockId: `${params.body.blockId}`,
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}account/GetGramList`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          PT: process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        body: await EncryptPreLogin(JSON.stringify(rowData)),
      }
    );
    const data = await response.text();
    const data1 = await DecryptPreLogin(data);
    const encodedString = data1;
    const res = JSON.parse(htmlDecode(encodedString));
    return res;
  }
);

export const getDistict = createAsyncThunk(
  "UserManagement/getDistict",
  async (params) => {
    const rowData = {
      stateId: `${params.body.stateID}`,
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}account/GetDistrictList`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          PT: process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        body: await EncryptPreLogin(JSON.stringify(rowData)),
      }
    );
    const data = await response.text();
    const data1 = await DecryptPreLogin(data);
    const encodedString = data1;
    const res = JSON.parse(htmlDecode(encodedString));
    return res;
  }
);

export const postalPincodeAPI = createEncryptedAsyncThunk(
  "UserManagement/postalPincodeAPI",
  "account/PostalPincodeAPI",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      postoffice: params.postoffice || '',
      pincode: params.pincode || '',
      serviceId: params.serviceId || 0,
    }),
  }
);

export const SendOTPorVerifyOTP = createAsyncThunk(
  "UserManagement/SendOTPorVerifyOTP",
  async (params) => {
    const rowData = {
      // type: "MOBILE_VERIFICATION",
      // otp: "",
      // auth_mode: 0,
      otp: params.otp || "",
      auth_mode: 0,
      type: "MOBILE_VERIFICATION",
      userName: "",
      role: 0,
      mode: {
        mode1: "SMS",
        mode2: "",
      },
      receiverDetails: {
        mobileNo: params.mobileNumber,
        emailId: "",
      },
    };
    // console.log("rowData :",rowData)
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}Service/VerifyPreUserOTP`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          PT: process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        body: await EncryptPreLogin(JSON.stringify(rowData)),
      }
    );
    const data = await response.text();
    const data1 = await DecryptPreLogin(data);
    const encodedString = data1;
    const res = JSON.parse(htmlDecode(encodedString));
    return res;
  }
);

export const generateMobileOtp = createAsyncThunk(
  "UserManagement/generateMobileOtp",
  async (params) => {
    const rowData = {
      type: "MOBILE_VERIFICATION",
      mode: {
        mode1: "SMS",
        mode2: "",
      },
      auth_mode: 0,
      receiverDetails: {
        mobileNo: params.mobileNumber,
        emailId: "",
      },
      ipaddress: params.ipAddress,
      substitutes: {
        additionalProp1: "",
        additionalProp2: "",
        additionalProp3: "",
      },
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}Service/GeneratePreUserOTP`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          PT: process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        body: await EncryptPreLogin(JSON.stringify(rowData)),
      }
    );
    const data = await response.text();
    const data1 = await DecryptPreLogin(data);
    const encodedString = data1;
    const res = JSON.parse(htmlDecode(encodedString));
    return res;
  }
);

export const chePincodeAvialable = createAsyncThunk(
  "UserManagement/chePincodeAvialable",
  async (params) => {
    const rowData = {
      pincode: params.pincode || "",
      state: params.state || "",
      city: params.city || "",
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}account/GetPincodeDetails`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          PT: process.env.REACT_APP_API_KEY,
        },
        body: await EncryptPreLogin(JSON.stringify(rowData)),
      }
    );
    const data = await response.text();
    const data1 = await DecryptPreLogin(data);
    const encodedString = data1;
    const res = JSON.parse(htmlDecode(encodedString));
    return res;
  }
);

export const userSignup = createAsyncThunk(
  "UserManagement/onboardingPreUser",
  async (params) => {
    const rowData = {
      nameTitle: params.nameTitle || "",
      emailAddress: params.emailAddress || "",
      firstName: params.firstName || "",
      middleName: params.middleName || "",
      lastName: params.lastName || "",
      primaryPhone: params.primaryPhone || "",
      primaryPhoneType: params.primaryPhoneType || 0,
      secondaryPhone: params.secondaryPhone || "",
      secondaryPhoneType: params.secondaryPhoneType || 0,
      role: _.toNumber(params.role) || 6,
      senior_ID: _.toNumber(params.senior_ID) || 1,
      business_Name: params.business_Name || "",
      business_Add: params.business_Add || "",
      business_Contact_No: params.business_Contact_No || "",
      business_Type: params.business_Type || "",
      state_ID: _.toNumber(params.state_ID) || 0,
      city_ID: _.toNumber(params.city_ID) || 0,
      pincode: params.pincode || "",
      area: params.area || "",
      landMark: params.landMark || "",
      address: params.address || "",
      created_By: _.toNumber(params.created_By) || 0,
      plan_id: _.toNumber(params.plan_id) || 0,
      aadhar_no: params.aadhar_no || "",
      pan_no: params.pan_no || "",
      whatsapp_no: params.whatsapp_no || "",
      block_add: params.block_add || "",
      gram_panchayat: params.gram_panchayat || "",
      post_office: params.post_office || "",
      police_thana: params.police_thana || "",
      gram: params.gram || "",
      other: params.other || "",
      gender: _.toNumber(params.gender) || 0,
      locationtype: _.toNumber(params.locationtype) || 0,
      dob: params.dob || "",
      custom_Attributes: {
        ip: `${params.ipAddress}`,
        deviceId: "string",
        deviceType: params.browserName || '',
        lattitude: `${params.lat}`,
        longitude: `${params.lng}`,
      },
    };
    // console.log('rowData :',rowData)
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}account/CreateUserPreLogin`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          PT: process.env.REACT_APP_API_KEY,
        },
        body: await EncryptPreLogin(JSON.stringify(rowData)),
      }
    );
    const data = await response.text();
    const data1 = await DecryptPreLogin(data);
    const encodedString = data1;
    const res = JSON.parse(htmlDecode(encodedString));
    return res;
  }
);

export const getRoles = createEncryptedAsyncThunk(
  "UserManagement/getRoles",
  "account/GetUserRoles",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      adminRequired: params.adminRequired || false
    }),
  }
);

export const updateRoleMaster = createEncryptedAsyncThunk(
  "UserManagement/updateRoleMaster",
  "account/UpdateRoleMaster",
  {
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      role_id: params.role_id,
      isactive: params.isactive,
      isvisible: params.isvisible,
      default_kyc_status: params.default_kyc_status,
      fund_transfer_required: params.fund_transfer_required,
      fund_transfer_request_roles: params.fund_transfer_request_roles
    }),
  }
);

export const getAllUsersByRole = createEncryptedAsyncThunk(
  "UserManagement/getAllUsersByRole",
  "account/GetUserDetailsByRole",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      role: params.roleId || 0,
      senior_id: params.seniorId || 0,
      documentRequired: params.documentRequired || 0,
      listloadRequired: params.listloadRequired || 0,
      status: params.status || 3,
      apiUser: params.apiUser || 3,
    }),
  }
);

export const updateEnableAppLogin = createEncryptedAsyncThunk(
  "UserManagement/updateEnableAppLogin",
  `Service/UpdateAppLoginEnable`,
  {
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      requestUser: params.userId || [0],
      status: params.status || 0,
      key: params.key || "",
    }),
  }
);

export const getUsersServiceStatus = createEncryptedAsyncThunk(
  "UserManagement/getUsersServiceStatus",
  `Service/GetUserServiceStatusDetails`, // Function that takes params and returns the URL
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ipAddress: params.location.ip,
    }),
  }
);

export const getOnboardingExcelDetailAction = createEncryptedAsyncThunk(
  "UserManagement/getOnboardingExcelDetailAction",
  `account/GETONBORDINGEXCELDETAILS`, // Function that takes params and returns the URL
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      userIDOnboard: params.userIDOnboard || [0]
    }),
  }
);

export const updateOnbordingExcelDetailsAction = createEncryptedAsyncThunk(
  "UserManagement/updateOnbordingExcelDetailsAction",
  `Service/UpdateOnbordingExcelDetails`, // Function that takes params and returns the URL
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      excelData: params.excelData,
    }),
  }
);

export const updateUserLienAmountAction = createEncryptedAsyncThunk(
  "managementSlice/updateUserLienAmountAction",
  "Service/UpdateUserLienAmount",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      updateUserId: params.updateUserId,
      lienAmount: params.lienAmount,
    }),
  }
);

export const updateUserPGLienAmountAction = createEncryptedAsyncThunk(
  "managementSlice/updateUserPGLienAmountAction",
  "Service/UpdateUserPGLimit",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      updateUserId: params.updateUserId,
      pgLimit: params.lienAmount,
    }),
  }
);

export const updateUserDetail = createEncryptedAsyncThunk(
  "UserManagement/updateUserDetail",
  "account/UpdateUserDetails",
  {
    prepareBody: (params) => {
      return {
        userID: params.currentUser.userGuid,
        updateUserID: _.toString(params.userID),
        otp: params.otp || "",
        emailAddress: params.emailAddress || "",
        mobile: params.primaryPhone || "",
        firstname: params.firstName || "",
        lastname: params.lastName || "",
        middlename: params.middleName || "",
        plan_Id: _.toNumber(params.plan_id) || 0,
        primaryPhoneType: params.primaryPhoneType || "0",
        status: params.status || 0,
        apiUserStatus: params.api_user || 0,
        pincode: params.pincode || "",
        whatsapp_no: params.whatsapp_no || "",
        block_add: params.block_add || "",
        gram_panchayat: params.gram_panchayat || "",
        post_office: params.post_office || "",
        police_thana: params.police_thana || "",
        gram: params.gram || "",
        other: params.other || "",
        updatedBy: params.updatedBy || 0,
        secondryno: params.secondaryPhone || "",
        landmark: params.landMark || "",
        business_Name: params.business_Name || "",
        business_Contact_No: params.business_Contact_No || "",
        business_Add: params.business_Add || "",
        address: params.address || "",
        dob: params.dob || "",
        city_ID: _.toNumber(params.city_ID) || 0,
        state_ID: _.toNumber(params.state_ID) || 0,
        nameTitle: `${params.nameTitle}` || '',
      };
    },
  }
);

export const createNewUsers = createEncryptedAsyncThunk(
  "UserManagement/createNewUsers",
  "account/CreateUser",
  {
    prepareBody: (params) => {
      const list = ({
        userID: params.currentUser.userGuid,
        nameTitle: params.nameTitle,
        username: "",
        password: "",
        tpin: params.tpin || "",
        emailAddress: params.emailAddress,
        firstName: params.firstName,
        middleName: params.middleName,
        lastName: params.lastName,
        primaryPhone: params.contactNumber,
        primaryPhoneType: 0,
        secondaryPhone: params.secondaryPhone,
        secondaryPhoneType: 0,
        role: params.roleId,
        senior_ID: params.seniorID || params.senior_ID || params.currentUser.userId,
        business_Name: params.business_Name,
        business_Add: params.business_Add,
        business_Contact_No: params.business_Contact_No,
        business_Type: params.business_Type || "",
        state_ID: params.state_ID,
        city_ID: params.city_ID,
        pincode: params.pincode,
        area: params.area || "",
        landMark: params.landMark,
        address: params.address,
        created_By: params.created_By || 0,
        plan_id: params.planList || 0,
        whatsapp_no: params.whatsapp_no || '',
        block_add: params.block_add || '',
        gram_panchayat: params.gram_panchayat || '',
        post_office: params.post_office || '',
        police_thana: params.police_thana || '',
        gram: params.gram || '',
        other: params.other || "",
        dob: params.dob,
        custom_Attributes: {
          ip: params.location.ip,
          deviceId: "",
          // deviceType: '',
          deviceType: params.location.deviceType,
          lattitude: params.location.lattitude,
          longitude: params.location.longitude,
        },
      })
      return list
    },
  }
);

export const resetPasswordUser = createEncryptedAsyncThunk(
  "UserManagement/resetPasswordUser",
  `Service/ResetPassword`, // Function that takes params and returns the URL
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      resetUserId: params.userID,
      ipaddress: params.location.ip,
      password: params.password || "",
      resettype: params.resettype || "",
    }),
  }
);

export const agentIDUpdate = createEncryptedAsyncThunk(
  "UserManagement/agentIDUpdate",
  "Service/CreateUserMasterData",
  {
    prepareBody: (params) => ({
      userId: Number(params.userId),
      keyDatas: [
        {
          key: params.agentType,
          value: params.agentID,
        },
      ],
    }),
  }
);

export const submitKYCDetailsAdmin = createEncryptedAsyncThunk(
  "UserManagement/submitKYCDetailsAdmin",
  "account/UpdateEKyc",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      updateUserId: _.toNumber(params.userId) || 0,
      dataKeyValueLists: [
        {
          dataKey: params.transType || "",
          dataValue: params.dataValue,
          dataValue1: JSON.stringify(params.dataValue1),
          dataValue2: params.dataValue2 || "",
          dataValue3: params.dataValue3 || "",
          dataStatus: params.dataStatus || 0,
        },
      ],
      created_By: 0,
      updateKYCDataFlag: true,
    }),
  }
);

export const updateSeniorMapping = createEncryptedAsyncThunk(
  "UserManagement/updateSeniorMapping",
  "account/UpdateSeniorId",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      changeUserId: params.mapUserId || 0,
      senior_Id: params.selectSenior || 0,
    }),
  }
);

export const UploadDocumentList = createEncryptedAsyncThunk(
  "UserManagement/UploadDocumentList",
  "account/AddUserDocuments",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      adduserId: `${params.userID}` || '',
      dataKeyValueLists: params.formData || [],
      created_By: params.created_By || params.currentUser.userId,
    }),
  }
);

export const UpdateKYCDocuments = createEncryptedAsyncThunk(
  "UserManagement/UpdateKYCDocuments",
  "account/UpdateUserDocuments",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      updateuserId: `${params.userID}` || '',
      dataKeyValueLists: params.formData || [],
      created_By: params.created_By || params.currentUser.userId,
    }),
  }
);

export const verifyPANCard = createEncryptedAsyncThunk(
  "UserManagement/verifyPANCard",
  "account/PSPanVerify",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      refid: params.refid || "",
      pannumber: params.panNumber || '',
      serviceId: params.serviceId || 0
    }),
  }
);

export const sendOTPAdhar = createEncryptedAsyncThunk(
  "UserManagement/UpdateKYCDocuments",
  "account/PSAadharGenerateOTP",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      id_number: params.adharNumber || '',
      serviceId: params.serviceId || 0
    }),
  }
);

export const VerifyAdharOTPAdhar = createEncryptedAsyncThunk(
  "UserManagement/VerifyAdharOTPAdhar",
  "account/PSAadharVerifyOTP",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      otp: params.otp || '',
      client_id: params.clientRefId || '',
      serviceId: params.serviceId || 0
    }),
  }
);

export const getAllUsersPreLogin = createAsyncThunk(
  "UserManagement/getAllUsersPreLogin",
  async (params) => {
    const rowData = {
      userID: params.currentUser.userGuid,
      preloginuserid: `${params.userid}`,
      ipAddress: "192.128.11.103",
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}account/GetPreLoginUserDetails`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          PT: process.env.REACT_APP_API_KEY,
          Authorization: `Bearer ${params.Usertoken}`,
        },
        body: await EncryptPreLogin(JSON.stringify(rowData)),
      }
    );
    const data = await response.text();
    const data1 = await DecryptPreLogin(data);
    const encodedString = data1;
    const res = JSON.parse(htmlDecode(encodedString));
    return res;
  }
);

export const RejectPreLoginUser = createEncryptedAsyncThunk(
  "UserManagement/RejectPreLoginUser",
  "account/RejectUserPreLogin",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      preUserID: `${params.userID}`,
      reason: params.reason,
    }),
  }
);

export const onboardingPreUser = createEncryptedAsyncThunk(
  "UserManagement/onboardingPreUser",
  "account/CreateUserFromPreLogin",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      preUserId: params.userid,
      ipAddress: "192.128.11.103",
    }),
  }
);

// EKO Onboarding ---------start
export const EKOEmployeeVerification = createEncryptedAsyncThunk(
  "UserManagement/EKOEmployeeVerification",
  "Service/EKO_EmployeeVerification",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      initiator_id: params.initiator_id || "",
      user_code: params.user_code || "",
      phone: params.phone || "",
      source: params.source || "",
      client_ref_id: params.client_ref_id || "",
      serviceId: params.serviceId || 0,
    }),
  }
);

export const EKOGSTIN = createEncryptedAsyncThunk(
  "UserManagement/EKOGSTIN",
  "Service/EKO_GSTIN",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      initiator_id: params.initiator_id || "",
      user_code: params.user_code || "",
      gstin: params.gstin || "",
      business_name: params.business_name || "",
      source: params.source || "",
      client_ref_id: params.client_ref_id || "",
      serviceId: params.serviceId || 0,
    }),
  }
);

export const EKOBankAccountVerification = createEncryptedAsyncThunk(
  "UserManagement/EKOBankAccountVerification",
  "Service/EKO_BankAccountVerification",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      initiator_id: params.initiator_id || "",
      user_code: params.user_code || "",
      bank_account: params.bank_account || "",
      ifsc: params.ifsc || "",
      client_ref_id: params.client_ref_id || "",
      serviceId: params.serviceId || 0,
    }),
  }
);

export const EKOIPVerification = createEncryptedAsyncThunk(
  "UserManagement/EKOIPVerification",
  "Service/EKO_IPVerification",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      initiator_id: params.initiator_id || "",
      user_code: params.user_code || "",
      ip_address: params.ip_address || "",
      source: params.source || "",
      client_ref_id: params.client_ref_id || "",
      serviceId: params.serviceId || 0,
    }),
  }
);

export const EKOPANAdvance = createEncryptedAsyncThunk(
  "UserManagement/EKOPANAdvance",
  "Service/EKO_PANAdvance",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      initiator_id: params.initiator_id || "",
      user_code: params.user_code || "",
      pan: params.pan || "",
      name: params.name || "",
      dob: params.dob || "",
      source: params.source || "",
      client_ref_id: params.client_ref_id || "",
      serviceId: params.serviceId || 0,
    }),
  }
);

export const EKOCIN = createEncryptedAsyncThunk(
  "UserManagement/EKOCIN",
  "Service/EKO_CIN",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      initiator_id: params.initiator_id || "",
      user_code: params.user_code || "",
      cin: params.cin || "",
      source: params.source || "",
      client_ref_id: params.client_ref_id || "",
      serviceId: params.serviceId || 0,
    }),
  }
);

export const EKOGeoLocation = createEncryptedAsyncThunk(
  "UserManagement/EKOGeoLocation",
  "Service/EKO_GeoLocation",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      initiator_id: params.initiator_id || "",
      user_code: params.user_code || "",
      latitude: params.latitude || "",
      longitude: params.longitude || "",
      source: params.source || "",
      client_ref_id: params.client_ref_id || "",
      serviceId: params.serviceId || 0,
    }),
  }
);

export const EKOSendAadharOTP = createEncryptedAsyncThunk(
  "UserManagement/EKOSendAadharOTP",
  "Service/EKO_SendAadharOTP",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      initiator_id: params.initiator_id || "",
      user_code: params.user_code || "",
      aadhar: params.aadhar || "",
      is_consent: params.is_consent || "",
      access_key: params.access_key || "",
      caseId: params.caseId || "",
      realsourceip: params.realsourceip || "",
      source: params.source || "",
      client_ref_id: params.client_ref_id || "",
      serviceId: params.serviceId || 0,
    }),
  }
);

export const EKONameMatching = createEncryptedAsyncThunk(
  "UserManagement/EKONameMatching",
  "Service/EKO_NameMatching",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      initiator_id: params.initiator_id || "",
      user_code: params.user_code || "",
      name_1: params.name_1 || "",
      name_2: params.name_2 || "",
      source: params.source || "",
      client_ref_id: params.client_ref_id || "",
      serviceId: params.serviceId || 0,
    }),
  }
);
// EKO Onboarding ---------end

export const quickekycAadharSendOTP = createEncryptedAsyncThunk(
  "UserManagement/quickekycAadharSendOTP",
  "account/QuickekycAadharSendOTP",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      key: params.key || "",
      id_number: params.id_number || "",
      serviceId: params.serviceId || 0,
    }),
  }
);

export const quickekycAadharVerifyOTP = createEncryptedAsyncThunk(
  "UserManagement/quickekycAadharVerifyOTP",
  "account/QuickekycAadharVerifyOTP",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      key: params.key || "",
      request_id: params.request_id || "",
      otp: params.otp || "",
      serviceId: params.serviceId || 0,
    }),
  }
);

export const quickekycPanVerify = createEncryptedAsyncThunk(
  "UserManagement/quickekycPanVerify",
  "account/QuickekycPanVerify",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid || "",
      key: params.key || "",
      id_number: params.id_number || "",
      serviceId: params.serviceId || 0,
    }),
  }
);

export const updateAEPSFlagsAction = createEncryptedAsyncThunk(
  "UserManagement/updateAEPSFlagsAction",
  `Service/UpdateAEPSFlags`,
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      aepsUserId: _.toNumber(params.aepsUserId) || 0,
      api_id: params.api_id || 1,
      key: params.key,
      value: params.value,
    }),
  }
);

export const credoPayAEPSManualOnboardingAction = createEncryptedAsyncThunk(
  "UserManagement/credoPayAEPSManualOnboardingAction",
  `account/CredoPay_AEPSManualOnboarding`,
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      retailerUserID: _.toNumber(params.aepsUserId) || 0,
      merchantCode: params.merchantCode || '',
      merchantTerminalCode: params.merchantTerminalCode || '',
      serviceId: params.serviceId || 0,
    }),
  }
);

export const getPGAmountMasterDataAction = createEncryptedAsyncThunk(
  "UserManagement/getPGAmountMasterDataAction",
  "account/GetPGAmountMasterData",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      key: params.key || "",
    }),
  }
);
export const updatePGAmountMasterDataAction = createEncryptedAsyncThunk(
  "UserManagement/updatePGAmountMasterDataAction",
  "account/UpdatePGAmountMasterData",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      key: params.key || "",
      value: params.amount,
    }),
  }
);

export const UserManagement = createSlice({
  name: "UserManagement",
  initialState,
  reducers: {},
});

// export const {
//   FetchSuccess,
//   FetchFailed,
//   DeleteSuccess,
//   DeleteFailed,
//   DeleteInitial,
//   creditAmountSuccess,
//   creditAmountFailed,
// } = UserManagement.actions;

export default UserManagement.reducer;
